export const CHANGE = "Change";
export const LAST_PRICE = "Last price on the day of event";
export const CLOSING_PRICE = "Previous closing price";
export const STOCK_MARKET_NAME = "Stock market name";
export const TICKER = "Ticker";
export const COMPANY_NAME = "Company name";
